import { CHAT_LINK_MAX_LENGTH } from './limits'

/**
 * Finds the link in a Message's text that gets a Link preview, the way the server does
 * (orbit-backend `chat-link.ts`), so the composer previews the same one.
 */

const LINK = /https?:\/\/[^\s<>"]+/gi

/** Punctuation that ends the sentence around a link rather than the link itself. */
const TRAILING = /[.,;:!?'’"”]$/

/**
 * The first http(s) link in `text`, without the punctuation of the sentence around it
 * or a closing bracket the link doesn't open.
 */
export const firstLinkIn = (text: string | null): string | null => {
	if (text == null) return null
	for (const [match] of text.matchAll(LINK)) {
		const link = trimLink(match)
		if (link.length <= CHAT_LINK_MAX_LENGTH && hasHost(link)) return link
	}
	return null
}

/** The link's host without `www.`, as the composer names a link before its preview arrives. */
export const hostOf = (link: string): string | null => {
	try {
		return new URL(link).hostname.replace(/^www\./, '') || null
	} catch {
		return null
	}
}

/** A link without the punctuation of the sentence around it, or a closing bracket it doesn't open. */
export const trimLink = (link: string): string => {
	let trimmed = link
	for (;;) {
		if (TRAILING.test(trimmed)) trimmed = trimmed.slice(0, -1)
		else if (trimmed.endsWith(')') && count(trimmed, ')') > count(trimmed, '(')) trimmed = trimmed.slice(0, -1)
		else return trimmed
	}
}

const count = (text: string, character: string): number => text.split(character).length - 1

const hasHost = (link: string): boolean => {
	try {
		return new URL(link).hostname !== ''
	} catch {
		return false
	}
}
